import { isAxiosError } from 'axios';

const run = async <E, T>(promise: any): Promise<[E, T]> => {
  try {
    const data = await promise;
    return [<E>undefined, <T>data];
  } catch (e) {
    const err = isAxiosError(e) && e.response && e.response.data ? e.response?.data : e;
    return [<E>err, <T>undefined];
  }
};

export const apiHandle = async <T>(promise: any): Promise<[any, T]> => {
  return run<any, T>(promise);
};

// export const buildFormData = (formData: FormData, data: any, parentKey?: string) => {
//   if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
//     Object.keys(data).forEach(key => {
//       buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
//     });
//   } else {
//     const value = data == null ? '' : data;

//     if (parentKey) formData.append(parentKey, value);
//   }
// };

// INFO: A função comentada acima monta objetos e arrays com index
//       Ex: objeto[chave1][chave2] | array[0] | array[0][chave]
//       Caso seja necessário utilizar novamente, deixei aqui informado
//       -- Jonathan
export const buildFormData = (formData: FormData, data: any) => {
  for (const k in data) {
    if (data[k] instanceof File || data[k] instanceof Blob) {
      formData.append(k, data[k]);
    } else if (Array.isArray(data[k]) || typeof data[k] === 'object') {
      formData.append(k, JSON.stringify(data[k]));
    } else {
      formData.append(k, data[k]);
    }
  }
}